import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { UtilityService } from '../utility';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  constructor(private httpClient: HttpClient) {}

  private baseMap: Highcharts.GeoJSON = undefined;
  private mapsCdmUrl = 'assets/maps'; // "https://code.highcharts.com/mapdata/countries/us" // CORS problems

  private httpHeaders = new HttpHeaders({
    'No-token': 'true',
  });

  getBaseMap(useBuffered = true): Observable<Highcharts.GeoJSON> {
    if (this.baseMap && useBuffered) {
      return of(UtilityService.cloneObject<Highcharts.GeoJSON>(this.baseMap));
    }

    return this.httpClient
      .get<Highcharts.GeoJSON>(`${this.mapsCdmUrl}/us-all.geo.json`, {
        headers: this.httpHeaders,
      })
      .pipe(
        tap((map) => {
          this.baseMap = UtilityService.cloneObject<Highcharts.GeoJSON>(map);
          return map;
        })
      );
  }

  getStateMap(state: string): Observable<Highcharts.GeoJSON> {
    return this.httpClient.get<Highcharts.GeoJSON>(
      `${this.mapsCdmUrl}/${state}-all.geo.json`,
      { headers: this.httpHeaders }
    );
  }
}
